import type { TransactionReturnType } from "../../types"
import type { Abi, Address } from "viem"
import type { Config } from "wagmi"

import { thickV2CreateAndInitializePoolAbi } from "@/domains/abis/thick-v2-nfpm-abi"

import { simulatedTransaction } from "../../simulated-transaction"

type CreateThickV2NfpmPoolProps = {
  account: Address
  chainId: number
  config: Config
  token0Address: Address
  token1Address: Address
  tickSpacing: number
  sqrtPriceX96: bigint
  nfpManagerAddress: Address
}

export const createThickV2NfpmPool = async ({
  account,
  chainId,
  config,
  token0Address,
  token1Address,
  tickSpacing,
  sqrtPriceX96,
  nfpManagerAddress,
}: CreateThickV2NfpmPoolProps): Promise<TransactionReturnType> => {
  try {
    return await simulatedTransaction({
      config,
      simulateArgs: {
        abi: thickV2CreateAndInitializePoolAbi as Abi,
        account,
        address: nfpManagerAddress,
        args: [token0Address, token1Address, tickSpacing, sqrtPriceX96],
        chainId,
        functionName: "createAndInitializePoolIfNecessary",
      },
    })
  } catch (error: unknown) {
    console.error("createThickV2NfpmPool", error)
    return {
      success: false,
      error: error instanceof Error ? error.message : "Unknown error",
      code: error instanceof Error && "code" in error ? Number((error as { code: string }).code) : 0,
    }
  }
}
